let braintreeSubmit = () => {
	console.error(new Error('Braintree was not successfully initialized'));
};

module.exports = {
	init: (config) => {
		let dropinConfig = {
			authorization: window.iq.braintreeAuthToken,
			container: config.containerId,
			card: {
				cardholderName: {
					required: true
				}
			},
			venmo: config.venmo,
			paypal: config.paypal
		};
		if ('applePay' in config) {
			dropinConfig.applePay = {
				...config.applePay,
				paymentRequest: {
					requiredBillingContactFields: ['postalAddress'],
					...(config.applePay.paymentRequest || {})
				}
			};
		}
		if (window.iq.googlePayMerchant !== '') {
			if ('googlePay' in config) {
				dropinConfig.googlePay = {
					googlePayVersion: 2,
					merchantInfo: {
						merchantId: window.iq.googlePayMerchant
					},
					transactionInfo: {
						currencyCode: 'USD',
						totalPriceStatus: 'FINAL',
						totalPrice: '1.00'
					},
					allowedPaymentMethods: [
						{
							type: 'CARD',
							parameters: {
								billingAddressRequired: true,
								billingAddressParameters: {
									format: 'FULL',
									phoneNumberRequired: false
								}
							}
						}
					]
				};
				if ('transactionInfo' in config.googlePay) {
					dropinConfig.googlePay.transactionInfo = {
						...dropinConfig.googlePay.transactionInfo,
						...config.googlePay.transactionInfo
					};
				}
			}
		}
		// console.log('braintree dropin config ', dropinConfig);
		window.jQuery(config.containerId).empty();
		window.braintree.dropin.create(dropinConfig, function gatewayHandler(createErr, instance) {
			if (createErr) {
				return console.error(createErr);
			}

			braintreeSubmit = function () {
				if ('submitBtnSelector' in config) {
					window.jQuery(config.submitBtnSelector).prop('disabled', 'disabled');
				}
				instance.requestPaymentMethod(function (err, payload) {
					if (err) {
						window.jQuery(config.submitBtnSelector).prop('disabled', false);
						if (err.message === 'No payment method is available.') {
							//when multiple possibilities exist, like credit, google pay, and venmo, this error can be thrown
							//if the user doesn't select any of them before hitting submit.
							if (window.jQuery('.braintree-googlePay').is(':visible')) {
								alert('Please click the Google Pay button to continue');
							} else if (window.jQuery('.braintree-paypal').is(':visible')) {
								alert('Please click the PayPal Checkout button to continue');
							} else if (window.jQuery('.braintree-applePay').is(':visible')) {
								alert('Please click the Apple Pay button to continue');
							} else {
								alert(
									'Please select a payment method. If you selected a non-credit card payment method, please click their payment button to continue.'
								);
							}
						}
						return console.error(err);
					}
					// console.log('braintree token payload', payload);
					if (config.onSubmitting) {
						config.onSubmitting();
					}
					window.jQuery('#paymentToken').val(payload.nonce).closest('form').submit();
				});
			};
		});
	},
	update: () => {
		/*
			NOTE:
			Braintree should never do anything for update(). Their drop-in UI doesn't support inline updates,
			so previously we tried re-running init; but then your entered payment details (CC#/etc) get thrown away
			and you either get stuck in a loop or an impassable state:
			enter details -> click submit -> "update" -> deletes details because reinit -> awaiting details

			The rammification of this decision is that all screens that need to update the amount after gateway initialization
			but before tokenization must perform the reinit themselves at the right time (e.g. when the necessary fields are updated).
		*/
	},
	tokenize: () => {
		braintreeSubmit();
	}
};
